import(/* webpackMode: "eager" */ "/var/www/service-geek/apps/web/src/app/page.tsx");
